import React, { forwardRef, useRef, useState, useMemo } from "react";
import { Tabs } from "antd";
// import SnapshotIndex from "./component/SnapshotIndex";
import AreaIndex from "./component/AreaIndex";
import CityIndex from "./component/CityIndex";
import SupervisorIndex from "./component/SupervisorIndex";

const TabsIndex = forwardRef((props, ref) => {
  const [tabsKey, setTabsKey] = useState("4");
  const [mountedTabs, setMountedTabs] = useState(new Set(["4"]));

  const snapshotRef = useRef(null);
  const cityRef = useRef(null);
  const areaRef = useRef(null);
  const supervisorRef = useRef(null);

  const items = useMemo(() => [
    // {
    //   key: "1",
    //   label: "Vacancy Snapshot",
    //   children: <SnapshotIndex ref={snapshotRef} />,
    // },
        {
      key: "4",
      label: "Vacancy by Supervisor",
      children: <SupervisorIndex ref={supervisorRef} />,
    },
    {
      key: "2",
      label: "Vacancy by City",
      children: <CityIndex ref={cityRef} />,
    },
    {
      key: "3",
      label: "Vacancy by Area",
      children: <AreaIndex ref={areaRef} />,
    },

  ], []);

  const handleChange = (key) => {
    setTabsKey(key);
    setMountedTabs(prev => new Set(prev).add(key));
      switch(key) {
        case "1":
          snapshotRef.current?.refresh?.();
          break;
        case "2":
          cityRef.current?.refresh?.();
          break;
        case "3":
          areaRef.current?.refresh?.();
          break;
        case "4":
          supervisorRef.current?.refresh?.();
          break;
        default:
          break;
      }
  };

  return (
    <div>
      <Tabs 
        activeKey={tabsKey} 
        items={items} 
        onChange={handleChange}
        destroyInactiveTabPane={false}
      />
    </div>
  );
});

export default TabsIndex;